//路由配置,引入路由插件vue-router
import VueRouter from 'vue-router'

//引入路由组件,路径与组件进行映射(路由规则)

//暴露创建对象VueRouter
export default new VueRouter({
    //多个路由配置-router(s)
    routes: [
        {
            //路径
            path: '/',
            name: 'HomePage',
            //组件
            component: () => import('@/components/HomePage.vue'),
        },
        {
            path: '/admin/marquee',
            component: () => import('@/components/MarqueeAdmin'),
            meta: { hidden: true }
        }

    ]
})